import { useSecondaryPage } from '@/PageManager'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'
import { getNoteBech32Id } from '@/lib/event'
import { toNote } from '@/lib/link'
import { Copy01Icon, Link01Icon } from '@hugeicons/core-free-icons'
import { HugeiconsIcon } from '@hugeicons/react'
import { AddressPointer, EventPointer } from '@nostr/tools/nip19'
import { useTranslation } from 'react-i18next'

export default function ListEventMenu({ pointer }: { pointer?: AddressPointer | EventPointer }) {
  const { t } = useTranslation()
  const { push } = useSecondaryPage()
  if (!pointer) return null
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center text-muted-foreground hover:text-foreground pl-2 h-full">
          <HugeiconsIcon icon={Link01Icon} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem onClick={() => navigator.clipboard.writeText(getNoteBech32Id(pointer))}>
          <HugeiconsIcon icon={Copy01Icon} />
          {t('Copy event ID')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => push(toNote(pointer))}>
          <HugeiconsIcon icon={Link01Icon} />
          {t('Open event')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
